module.exports = __webpack_public_path__ + "media/images/talent/mv-01-594112007b7d37cd156fc9c134cc2ba3.png";